module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/3/3-fe7ce49361543a2ddbdbb887f48303ef.jpg";